export default "__VITE_ASSET__BqMaPqj9__"